import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewProduccion = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'produccion',
        name: 'Produccion',
        component: ViewProduccion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
